export const selectInput = () => ({
    '& .ant-select-selection': {
        fontSize: '0.875rem',
        width: 180,
        maxWidth: '100%',
    },
});
